import {
  VetAndExpertsCardItemProps,
} from "../components/VetAndExpertsCardItem";

export const vetsAndExpertsData: VetAndExpertsCardItemProps[] = [
  {
    image: {
      src: "/images/people/Patricia.webp",
      width: 498,
      height: 616,
    },
    quote: "Cats run on protein. Feeding them carbs is like putting water in a gas car. My cat’s been `fresh and fabulous since KatKin`.",
    author: "DR Patricia Pimenta",
    jobTitle: "Veterinary Surgeon, MA (Medicine of Cats) MRCVS",
    backgroundTheme: "blue",

  },
  {
    image: {
      src: "/images/people/Ryan.webp",
      width: 498,
      height: 616,
    },
    quote: "Half of cats are overweight or obese. They need high-quality protein to thrive. `A carnivore diet is king`.",
    author: "Ryan Honaker",
    jobTitle: "Head Scientist, PhD (Microbiology)",
    backgroundTheme: "green",
  },
  {
    image: {
      src: "/images/people/Rachael.webp",
      width: 498,
      height: 616,
    },
    quote: "Quality diet is a crucial part of preventative health care. Feeding fresh looks after `your cat’s nutritional needs`.",
    author: "Rachael Nind",
    jobTitle: "In-House Vet Nurse, KatKin",
    backgroundTheme: "orange",
  },
  {
    image: {
      src: "/images/people/Dominique.webp",
      width: 498,
      height: 616,
    },
    quote: "Gentler processing reduces the loss of nutrients during the cooking process. We do this by `cooking below 100°C`.",
    author: "Dominique Tarr",
    jobTitle: "Animal Nutritionist",
    backgroundTheme: "pink",
  },

];
